import theme from 'src/styles/theme'
import { Check2 } from '@styled-icons/bootstrap'
import { AlertTriangleOutline } from '@styled-icons/evaicons-outline'
import NumberFormat from 'react-number-format'
import { styledLastFraction } from './components/FractionLot/style'
import {
  BatchFraction, FractionFieldState, FractionItem, FractionTableHeader,
} from './FractionTypes'
import PrintIcon from '@mui/icons-material/Print'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import { Box } from '@mui/material'

export const createFractionListItem = (
  batchFraction: BatchFraction,
  removeMethod: (fraction: FractionItem) => void,
  isStyled: boolean,
  printMethod?: (fraction: FractionItem) => void,
) => {
  const { id_lotefracao, quantidade } = batchFraction

  const fraction: FractionItem = {
    batchFractionId: id_lotefracao,
    measureUnit: 'kilo(s)',
    qty: quantidade,
    qtyElement: (
      <NumberFormat
        name='fracao'
        decimalSeparator=','
        decimalScale={3}
        thousandSeparator='.'
        fixedDecimalScale
        value={quantidade}
        displayType='text'
      />
    ),
    styleCell: isStyled ? styledLastFraction : {},
    actions: <></>,
  }

  fraction.actions = (
    <Box
      sx={{
        display: 'flex',
        justifyContent: printMethod ? 'space-between' : 'center',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <DeleteOutlineIcon
        style={{ cursor: 'pointer', color: 'red' }}
        onClick={() => removeMethod(fraction)}
      />
      {printMethod && (
      <PrintIcon
        style={{ cursor: 'pointer', color: 'black' }}
        onClick={() => printMethod(fraction)}
        data-testid='print-fraction-test-id'
      />
      )}
    </Box>
  )
  return fraction
}

const formatNumbers = (value) => (Math.round(value * 100) / 100).toFixed(3)

export const formatBatchQuantities = (batch) => {
  batch.quantidade_util = formatNumbers(batch.quantidade_util)
  batch.quantidade_rejeitada = formatNumbers(batch.quantidade_rejeitada)
  batch.quantidade_total = formatNumbers(batch.quantidade_total)

  return batch
}

export const orderBatchesFromOldestToNewest = (batches) => batches.sort((firstBatch, secondBatch) => firstBatch.id_lote - secondBatch.id_lote)

export const FractionFieldStates: FractionFieldState[] = [
  {
    color: theme.colors.darkBlue,
    message: '',
    icon: <></>,
  },
  {
    color: theme.colors.red2,
    message: 'Fração abaixo do peso ideal',
    icon: <AlertTriangleOutline color={theme.colors.red2} size={15} />,
  },
  {
    color: theme.colors.confirm,
    message: 'Fração no peso ideal',
    icon: <Check2 color={theme.colors.confirm} size={15} />,
  },
  {
    color: theme.colors.yellow,
    message: 'Fração acima do peso ideal',
    icon: <AlertTriangleOutline color={theme.colors.yellow} size={15} />,
  },
]

export const fractionTableHeadersList: FractionTableHeader[] = [
  { name: 'qtyElement', label: 'fraction.form.value' },
  { name: 'measureUnit', label: 'fraction.table.header.measurement' },
  { name: 'actions', label: 'fraction.table.header.actions' },
]
